import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sendtoo_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

export default api;
